import React from "react";

export default function InputAmount({
  elem,
  data,
  formatMoney,
  credit,
  onChangeData,
}) {
  return (
    <div className="mb-2">
      <label for="comentario">
        {data.entryType === "credits" ? "Monto Líquido" : elem.label}
        <span className="obligatory"> *</span>
      </label>
      <input
        type="text"
        className="amountForm form-control input-sm textInput especialGroup formHover"
        name={elem.id}
        value={
          data.entryType === "credits"
            ? formatMoney(credit?.liquidAmount)
            : formatMoney(data?.amount)
        }
        onChange={(e) => {
          onChangeData(e.target.value, e.target.id);
        }}
        id={elem.id}
        aria-describedby="comentarioHelp"
        placeholder={
          data.entryType === "credits" ? "Monto líquido" : elem.placeholder
        }
      />
    </div>
  );
}
